<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/events',
          title: 'Events'
        }
      ]"
      :value="eventsPage.hero_section"
    >
      <template v-if="eventsPage.hero_section.cta" #cta>
        <HeroCta :value="eventsPage.hero_section.cta" />
      </template>
    </HeroSection>

    <ServiceCategoriesSection
      :value="eventsPage.service_categories_section"
      class="mb-16 hero-section hero-below-offset"
    />

    <LogoBarSection
      :items="logos"
      :value="eventsPage.logo_bar_section"
      class="mb-16"
    />

    <ServiceDetailSection
      class="mb-16"
      :value="eventsPage.service_detail_section"
    />

    <ReviewsSection :items="reviews" class="mb-16" />

    <PromotedResourcesSection
      :value="eventsPage.promoted_resources_section"
      class="mb-16"
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection :value="eventsPage.contact_cta_section" class="mb-16" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  eventsPage: {
    required: true,
    type: Object
  },
  logos: {
    required: true,
    type: Array
  },
  reviews: {
    required: true,
    type: Array
  }
})
</script>
